
import { CompanyInfo } from "./components/CompanyInfo";
import { ContactList } from "./components/ContactList";

interface Contact {
  id: string;
  full_name: string | null;
  title: string | null;
  work_email: string | null;
  linkedin_profile?: string | null;
  phone_number?: string | null;
  key_contact: boolean;
  avatar_url?: string | null;
}

interface CompanyCardProps {
  companyName: string;
  websiteUrl?: string;
  description?: string;
  contacts?: Contact[];
  logoUrl?: string;
  companyId?: string;
  fundId?: string;
  onLogoUpdate?: (newLogoUrl: string | null) => void;
}

export function CompanyCard({ 
  companyName, 
  websiteUrl, 
  description, 
  contacts = [],
  logoUrl,
  companyId,
  fundId,
  onLogoUpdate
}: CompanyCardProps) {
  // If we only have company info (no contacts), show the company info layout
  if (!(contacts?.length || 0)) {
    return (
      <CompanyInfo
        companyName={companyName}
        websiteUrl={websiteUrl}
        description={description}
        logoUrl={logoUrl}
        companyId={companyId}
        onLogoClick={() => {}}
        onLogoUpdate={onLogoUpdate}
      />
    );
  }

  // If we have contacts, show just the contacts section
  return <ContactList contacts={contacts} fundId={fundId} />;
}
